var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTournamentMoney(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.75 7.25v1h2.5v.838c.001.681.002 1.636-.501 2.39-.5.75-1.36 1.151-2.608 1.249a2.753 2.753 0 01-1.391.92v1.738H15a.75.75 0 010 1.5H9a.75.75 0 010-1.5h2.25v-1.739a2.753 2.753 0 01-1.39-.92c-1.249-.097-2.11-.498-2.609-1.248-.503-.755-.502-1.709-.501-2.39V8.25h2.5v-1h5.5zm-4 1.5V11a1.25 1.25 0 002.5 0V8.75h-2.5zm-2.483 1c.025.394.087.678.232.896.102.154.301.343.754.468A2.794 2.794 0 019.25 11V9.75h-.983zm6.483 0V11c0 .038 0 .076-.002.114.452-.125.65-.314.753-.468.145-.218.207-.502.232-.896h-.983z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 5a1 1 0 011 1v12a1 1 0 01-1 1H3a1 1 0 01-1-1V6a1 1 0 011-1h18zM5.482 6.5A1.75 1.75 0 013.5 8.482v7.036A1.75 1.75 0 015.482 17.5h13.036a1.75 1.75 0 011.982-1.982V8.482A1.75 1.75 0 0118.518 6.5H5.482z",
    fill: "currentColor"
  })));
}
SvgTournamentMoney.displayName = 'TournamentMoney';
export default SvgTournamentMoney;